module.exports = __webpack_public_path__ + "images/102_640.jpg";